"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
var EItemParticularity;
(function (EItemParticularity) {
    EItemParticularity["SCROLL"] = "SCROLL";
    EItemParticularity["QUEST_REWARD"] = "QUEST_REWARD";
    EItemParticularity["GUILD_ITEM"] = "GUILD_ITEM";
    EItemParticularity["ENCHANTING_TOOL"] = "ENCHANTING_TOOL";
    EItemParticularity["CRAFTING_TOOL"] = "CRAFTING_TOOL";
    EItemParticularity["BAG_4x4"] = "BAG_4x4";
    EItemParticularity["BAG_4x6"] = "BAG_4x6";
    EItemParticularity["BAG_5x6"] = "BAG_5x6";
    EItemParticularity["BAG_6x6"] = "BAG_6x6";
    EItemParticularity["BAG_7x6"] = "BAG_7x6";
})(EItemParticularity || (EItemParticularity = {}));
exports.default = EItemParticularity;
//# sourceMappingURL=EItemParticularity.js.map